var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable max-len */
import React from "react";
import BaseSvgIcon from "../Base";
var Cross = function (props) {
    return (React.createElement(BaseSvgIcon, __assign({}, props, { viewBox: "0 0 6 6" }),
        React.createElement("path", { d: "M3.32825,2.62125 L5.09625,0.85325 C5.29125,0.65825 5.29125,0.34225 5.09625,0.14625 C4.90025,-0.04875 4.58425,-0.04875 4.38925,0.14625 L2.62125,1.91425 L0.85325,0.14625 C0.65825,-0.04875 0.34225,-0.04875 0.14625,0.14625 C-0.04875,0.34225 -0.04875,0.65825 0.14625,0.85325 L1.91425,2.62125 L0.14625,4.38925 C-0.04875,4.58425 -0.04875,4.90025 0.14625,5.09625 C0.24425,5.19325 0.37225,5.24225 0.50025,5.24225 C0.62825,5.24225 0.75625,5.19325 0.85325,5.09625 L2.62125,3.32825 L4.38925,5.09625 C4.48625,5.19325 4.61425,5.24225 4.74225,5.24225 C4.87025,5.24225 4.99825,5.19325 5.09625,5.09625 C5.29125,4.90025 5.29125,4.58425 5.09625,4.38925 L3.32825,2.62125 Z" })));
};
export default Cross;
